import {
  GiftDeliveryStatus,
  GiftDeliveryType,
} from '@shared/api/giftDelivery/giftDelivery.interface';

export const statusLabel: Record<string, { text: string; className: string }> = {
  [GiftDeliveryStatus.WaitingAddress]: {
    text: '주소입력대기',
    className: 'bg-amber-100 text-amber-700',
  },
  [GiftDeliveryStatus.AddressSubmitted]: {
    text: '주소입력완료',
    className: 'bg-blue-100 text-blue-700',
  },
  [GiftDeliveryStatus.Preparing]: {
    text: '상품 준비중',
    className: 'bg-indigo-100 text-indigo-700',
  },
  [GiftDeliveryStatus.Shipping]: {
    text: '배송중',
    className: 'bg-purple-100 text-purple-700',
  },
  [GiftDeliveryStatus.Delivered]: {
    text: '배송완료',
    className: 'bg-green-100 text-green-700',
  },
  [GiftDeliveryStatus.Canceled]: {
    text: '취소',
    className: 'bg-red-100 text-red-700',
  },
};

export const typeLabel: Record<string, string> = {
  [GiftDeliveryType.Individual]: '개별배송',
  [GiftDeliveryType.Bulk]: '일괄배송',
};

export const typeBadgeStyle: Record<string, string> = {
  [GiftDeliveryType.Individual]: 'bg-cyan-100 text-cyan-800 border border-cyan-300',
  [GiftDeliveryType.Bulk]: 'bg-rose-100 text-rose-800 border border-rose-300',
};

export const nextStatusMap: Partial<Record<GiftDeliveryStatus, GiftDeliveryStatus>> = {
  [GiftDeliveryStatus.AddressSubmitted]: GiftDeliveryStatus.Preparing,
  [GiftDeliveryStatus.Preparing]: GiftDeliveryStatus.Shipping,
  [GiftDeliveryStatus.Shipping]: GiftDeliveryStatus.Delivered,
};

export const nextStatusLabel: Partial<Record<GiftDeliveryStatus, string>> = {
  [GiftDeliveryStatus.AddressSubmitted]: '준비중으로 변경',
  [GiftDeliveryStatus.Preparing]: '배송중으로 변경',
  [GiftDeliveryStatus.Shipping]: '배송완료 처리',
};

export const prevStatusMap: Partial<Record<GiftDeliveryStatus, GiftDeliveryStatus>> = {
  [GiftDeliveryStatus.Preparing]: GiftDeliveryStatus.AddressSubmitted,
  [GiftDeliveryStatus.Shipping]: GiftDeliveryStatus.Preparing,
};

export const prevStatusLabel: Partial<Record<GiftDeliveryStatus, string>> = {
  [GiftDeliveryStatus.Preparing]: '주소입력완료로 되돌리기',
  [GiftDeliveryStatus.Shipping]: '준비중으로 되돌리기',
};
